module.exports = __webpack_public_path__ + "static/media/lingotmartin.05a2ae5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pictures/lingotmartin.jpg
// module id = 329
// module chunks = 0